function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 0C2.69078 0 2.12595e-07 2.60924 0 5.81817C-1.4173e-07 8.15147 1.45718 10.6388 2.88305 12.5745C4.30891 14.5102 5.73564 15.8936 5.73564 15.8936C5.80596 15.9617 5.90129 16 6.00069 16C6.10009 16 6.19542 15.9617 6.26574 15.8936C6.26574 15.8936 7.69247 14.5102 9.11834 12.5745C10.5442 10.6388 12 8.15147 12 5.81817C12 2.60924 9.30922 0 6 0ZM6 0.72744C8.90389 0.72744 11.2498 3.00228 11.2498 5.81817C11.2498 7.84845 9.89455 10.2693 8.50796 12.1517C7.25382 13.8543 6.22804 14.8452 6 15.0709C5.77155 14.8448 4.74729 13.8539 3.49343 12.1517C2.10683 10.2693 0.750173 7.84845 0.750173 5.81817C0.750173 3.00228 3.09611 0.72744 6 0.72744V0.72744Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.99946 3.36865C4.58363 3.36865 3.42871 4.50434 3.42871 5.89497C3.42871 7.2856 4.58363 8.42128 5.99946 8.42128C7.4153 8.42128 8.57157 7.2856 8.57157 5.89497C8.57157 4.50434 7.4153 3.36865 5.99946 3.36865ZM5.99946 4.09046C7.01823 4.09046 7.83668 4.89434 7.83668 5.89497C7.83668 6.8956 7.01823 7.69948 5.99946 7.69948C4.98069 7.69948 4.1636 6.8956 4.1636 5.89497C4.1636 4.89434 4.98069 4.09046 5.99946 4.09046Z",
  fill: "currentColor"
});

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d45bc6f1.svg";
export { ForwardRef as ReactComponent };